export const EconomyListingHeader = ({
  selectedCountry,
  setSelectedCountry,
  allEconomies,
}) => {
  return (
    <div className="aem-Grid aem-Grid--12 aem-Grid--default--12 ">
      <div className=" tui_full_row_blue tui__enterprise_home_banner">
        <div className="touchui-container">
          <div className="tui_breadcrumb breadcrumb">
            <nav
              className="cmp-breadcrumb"
              aria-label="Breadcrumb"
              role="navigation"
            >
              <ol className="cmp-breadcrumb__list">
                <li className="cmp-breadcrumb__item">
                  <a className="cmp-breadcrumb__item-link" href="#">
                    <span className="name">Home</span>
                  </a>
                </li>
                <li className="cmp-breadcrumb__item">
                  <a className="cmp-breadcrumb__item-link" href="#">
                    <span className="name">Data</span>
                  </a>
                </li>
                <li className="cmp-breadcrumb__item">
                  <a className="cmp-breadcrumb__item-link" href="#">
                    <span className="name">Economies</span>
                  </a>
                </li>
              </ol>
            </nav>
          </div>

          <div className="teaser tui__enterprise_home_banner tui__enterprise_data_banner aem-GridColumn aem-GridColumn--default--12">
            <div className="cmp-teaser">
              <div className="cmp-teaser-container">
                <div className="cmp-teaser__content">
                  <h1 className="cmp-teaser__title">
                    Economies - Formal Enterprise Surveys
                  </h1>
                  <div className="cmp-teaser__description">
                    <p>
                      Formal Enterprise Surveys text here... This page presents
                      the World Bank Enterprise Surveys (WBES) data per
                      economies.{' '}
                    </p>
                  </div>
                </div>

                <div className="cmp-teaser__image">
                  <div className="cmp-image">
                    <img
                      src="https://webarchivedev.worldbank.org/accessibility/Enterprise/img/banner-vector-02.svg"
                      className="cmp-image__image"
                      alt="enterprise banner image"
                      title="enterprise logo"
                    />
                  </div>
                </div>
                <div className="cmp-teaser__action-container">
                  <div className="wrap_bready_dropdown">
                    <div className="research_dropdown ">
                      <div className="lp__dropdown_group">
                        <span
                          className="lp__dropdown_label sr-only"
                          id="dropdown_combo_elem_region"
                        >
                          Select Economy
                          <span className="sr-only">
                            On selection, leaving this page
                          </span>
                        </span>
                        <div className="lp__dropdown lp__secondary_dropdown">
                          <button
                            className="lp__dropdown_toggle"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                            id="exp_button_region"
                            aria-labelledby="dropdown_combo_elem_region exp_button_region"
                            role="button"
                          >
                            <span className="filter-option">
                              {selectedCountry.economyName}
                            </span>
                          </button>
                          <ul
                            className="dropdown-menu lp__dropdown_menu lp__secondary_dropdown_menu"
                            aria-labelledby="dropdown_combo_elem_region"
                            style={{ display: 'none' }}
                            role="menu"
                          >
                            {allEconomies.map((country, index) => (
                              <li role="menuitem" key={index}>
                                <a
                                  className="dropdown-item"
                                  href="#"
                                  onClick={() => setSelectedCountry(country)}
                                >
                                  {country.economyName}
                                </a>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
